export default function() {
  return this._root;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-quadtree/src/root.js
// module id = 1550
// module chunks = 0